import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

import Store from "@/store/store.js";
const store = Store;

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "system/comms/dashboard",
      name: "mainApp",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "TransactionLog",
          path: "system/comms/transaction/logs/:id",
          component: () => import("@/views/ched/TransactionLog.vue"),
        },
        {
          name: "Monitoring",
          path: "system/comms/monitoring",
          component: () => import("@/views/ched/Monitoring.vue"),
        },
        {
          name: "AssignedTransaction",
          path: "system/comms/assigned/transactions",
          component: () => import("@/views/ched/AssignedTransaction.vue"),
        },
        {
          name: "ArchivedTransaction",
          path: "/system/comms/archived/transactions",
          component: () => import("@/views/ched/ArchivedTransaction.vue"),
        },
        {
          name: "User",
          path: "system/comms/users",
          component: () => import("@/views/ched/User.vue"),
        },
        {
          name: "AccountProfile",
          path: "user/account/profile/view",
          component: () => import("@/views/ched/AccountProfile.vue"),
        },
        {
          name: "Notifications",
          path: "user/account/notifications",
          component: () => import("@/views/ched/notifications/Notification.vue"),
        },
        {
          name: "Dashboard",
          path: "/system/comms/dashboard",
          component: () => import("@/views/ched/dashboard/Dashboard.vue"),
        },
      ],
      meta: {
        permission: 'auth'
      }
    },

    {
      path: "/",
      redirect: "releasing",
      name: "mainReleasingApp",
      component: () => import("@/layouts/full-layout/Layout-Releasing"),
      children: [
        {
          name: "Releasing",
          path: "releasing",
          component: () => import("@/views/ched/Releasing.vue"),
        }
      ],
    },

    {
      path: "/authentication/user",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "BoxedLogin",
          path: "sign-in",
          component: () => import("@/views/authentication/BoxedLogin"),
        }
      ],
      meta: {
        permission: 'guest'
      }
    },
    {
      path: "/link/not_found",
      name: 'url-not-found',
      component: () => import("@/views/authentication/Error"),
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }

  if(store.getters.isAuthenticated && to.path == "/authentication/user/sign-in"){
    next({name: "mainApp"});
  }
  // if(store.getters.isAuthenticated && Number(store.getters.getUser.user_type) === 2 && to.path.includes('/system/payroll/detail/')){
  //   next({name: "url-not-found"});
  // }
  else if(to.matched.some(record => record.meta.permission === "auth") && !store.getters.isAuthenticated){
    next({name: "BoxedLogin"});
  }
  else if(to.matched.some(record => record.meta.permission === "guest")){
    next();
  }
  else{
    next();
  }


});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
